import { PILLARS, BADGES, ACTIONS } from "@/data/pillars";

export function computePillarScores(answers) {
  const scores = {};
  PILLARS.forEach((p) => {
    const vals = answers[p.id] || [];
    const filled = vals.filter((v) => Number.isFinite(v));
    if (filled.length === 0) {
      scores[p.id] = 0;
    } else {
      scores[p.id] = Math.round(
        (filled.reduce((a, b) => a + b, 0) / (filled.length * 5)) * 1000
      ) / 10;
    }
  });
  return scores;
}

export function computeTotal(scores) {
  const arr = PILLARS.map((p) => scores[p.id] || 0);
  return Math.round((arr.reduce((a, b) => a + b, 0) / arr.length) * 10) / 10;
}

export function getBadge(total) {
  for (const b of BADGES) {
    if (total >= b.min && total < b.max) return b.name;
  }
  return "Empresa Emergente";
}

export function getBenchmark(total) {
  return Math.max(5, Math.min(95, Math.round(total * 0.9 + 5)));
}

export function classify(score) {
  if (score >= 80) return { label: "Excelente", color: "#16A34A" };
  if (score >= 60) return { label: "Bom", color: "#65A30D" };
  if (score >= 40) return { label: "Atenção", color: "#FACC15" };
  return { label: "Crítico", color: "#DC2626" };
}

export function analyze(scores) {
  const ordered = PILLARS.map((p) => ({
    id: p.id,
    name: p.name,
    score: scores[p.id] || 0,
  })).sort((a, b) => a.score - b.score);

  const strongest = ordered[ordered.length - 1];
  const weakest = ordered[0];
  const priorities = ordered.slice(0, 3);

  return { strongest, weakest, priorities };
}

export function actionsFor(pillarId) {
  return ACTIONS[pillarId] || [];
}

export function isComplete(answers) {
  return PILLARS.every(
    (p) =>
      (answers[p.id] || []).filter((v) => Number.isFinite(v)).length === 5
  );
}
